import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/wxkf.jpg'


const _withScopeId = n => (_pushScopeId("data-v-522718aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0.24rem 0.45rem","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    style: {"width":"100%"}
  })
], -1))

import { ref } from "vue";
import { Dialog } from "vant";


const __default__ = {
  name: "CustomerService",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: boolean;
}





const handleConfirm = () => {
  window.location.href = "https://work.weixin.qq.com/kfid/kfc5b4dcd05b76e2af4";
  emit("update:modelValue", false);
};

const handleCancel = () => {
  emit("update:modelValue", false);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog).Component, {
    show: props.modelValue,
    title: "官方企微客服",
    confirmButtonText: "在线客服",
    "show-cancel-button": "",
    confirmButtonColor: "#386BF6",
    onConfirm: handleConfirm,
    onCancel: handleCancel,
    "get-container": "body"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})